import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

import { asyncGetDropdownCategories } from "./actions";

const EmptyCategoriesHelper = () => (
  <Typography component="span" variant="body2">
    <span>There are no categories created</span>
  </Typography>
);

export const CategoriesDropdown = ({ onChange, ...props }) => {
  const dispatch = useDispatch();

  const dropdownCategories = useSelector(
    (state) => state.categoriesReducer.dropdownCategories
  );

  useEffect(() => {
    dispatch(asyncGetDropdownCategories());
  }, [dispatch]);

  const onChangeLocal = (event) => {
    const { value } = event.target;

    if (value === -1) return;

    onChange(value);
  };

  return (
    <TextField
      variant="outlined"
      margin="normal"
      {...props}
      onChange={onChangeLocal}
      fullWidth
      select
    >
      <MenuItem value="-1">Choose a category</MenuItem>
      {dropdownCategories.map((category, index) => (
        <MenuItem
          key={category.categoryId}
          value={category.categoryId}
          divider={dropdownCategories.length - 1 === index}
        >
          {category.name}
        </MenuItem>
      ))}
      {!dropdownCategories.length && (
        <MenuItem key="create_option" value={-1}>
          <EmptyCategoriesHelper />
        </MenuItem>
      )}
    </TextField>
  );
};

CategoriesDropdown.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
};
